import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import 'flag-icons/css/flag-icons.min.css'
import magnetic from './directives/magnetic'
import cursor from './directives/cursor'

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.directive('magnetic', magnetic)
Vue.directive('cursor', cursor)

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
